import { Avatar, Box, Button, Menu, MenuItem } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { viewImage } from "../../utils/viewPDF";

function stringAvatar(name) {
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return {
      children: parts[0][0].toUpperCase(),
    };
  } else {
    return {
      children: `${parts[0][0]}${parts[1][0]}`.toUpperCase(),
    };
  }
}

const AdminNavbar = () => {
  const [org, setOrg] = useState();
  const [fileUrl, setFileUrl] = useState("");
  // const storedUser = JSON.parse(localStorage.getItem("user"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const getOrg = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        if(res.data.subscriptionEndDate < new Date().toISOString().split("T")[0]){
          alert("Your organization's subscription has ended. Please contact the admin.")
          localStorage.clear();
          navigate("/")
          return
        }
        setOrg(res.data);

        // Get image URL
        if (res.data.orgLogo) {
          const url = await viewImage(res.data.orgLogo, storedUser);
          setFileUrl(url);
        }
      } catch (error) {
        console.error("Error fetching organization:", error);
      }
    };
    getOrg();
  }, []);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // localStorage.clear();
    localStorage.clear();
    navigate("/");
  };

  return (
    <Box sx={{ background: "#ffffff" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 7,
        }}
      >
        <div>
          {org?.orgLogo &&
          <img
            src={fileUrl && fileUrl}
            alt="Organization Logo"
            style={{ height: 50 }}
          />}
        </div>
        <Box sx={{ display: "flex", columnGap: 3 }}>
          <Button
            className={location.pathname === "/admin" ? "btn-contained" : "btn-outlined"}
            sx={{
              padding: "5px 20px !important",
              border: "1px solid #1a71f6",
              width: 'fit-content'
            }}
            onClick={() => navigate("/admin")}
          >
            Dashboard
          </Button>
          <Button
            className={location.pathname.includes("vendors") ? "btn-contained" : "btn-outlined"}
            sx={{
              padding: "5px 20px !important",
              border: "1px solid #1a71f6",
              width: 'fit-content'
            }}
            onClick={() => navigate("/admin/vendors")}
          >
            Vendors
          </Button>
          <Button
            className={location.pathname.includes("currency") ? "btn-contained" : "btn-outlined"}
            sx={{
              padding: "5px 20px !important",
              border: "1px solid #1a71f6",
              width: 'fit-content'
            }}
            onClick={() => navigate("/admin/currency")}
          >
            Currency
          </Button>
          <Button
            className={location.pathname.includes("city") ? "btn-contained" : "btn-outlined"}
            sx={{
              padding: "5px 20px !important",
              border: "1px solid #1a71f6",
              width: 'fit-content'
            }}
            onClick={() => navigate("/admin/city")}
          >
            Origin/destination
          </Button>
          <Button
            className={location.pathname.includes("department") ? "btn-contained" : "btn-outlined"}
            sx={{
              padding: "5px 20px !important",
              border: "1px solid #1a71f6",
              width: 'fit-content'
            }}
            onClick={() => navigate("/admin/department")}
          >
            Departments
          </Button>
          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 2 }}>
            {storedUser.username}
            <Avatar
              {...stringAvatar(`${storedUser.username}`)}
              onClick={handleAvatarClick}
              sx={{ cursor: "pointer" }}
            />
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminNavbar;
